import axios from 'axios';
import Auth from '../lib/auth';
import utilsLib from './utils.lib';

export const GET_SALES_STATS_REQUEST = 'GET_SALES_STATS_REQUEST';
export const GET_SALES_STATS_SUCCESS = 'GET_SALES_STATS_SUCCESS';
export const GET_SALES_STATS_ERROR = 'GET_SALES_STATS_ERROR';

export const GET_PURCHASES_STATS_REQUEST = 'GET_PURCHASES_STATS_REQUEST';
export const GET_PURCHASES_STATS_SUCCESS = 'GET_PURCHASES_STATS_SUCCESS';
export const GET_PURCHASES_STATS_ERROR = 'GET_PURCHASES_STATS_ERROR';

export const CLEAN_STATS = 'CLEAN_STATS';

// Get sales stats
export function getSalesStats(year) {
    return async (dispatch) => {
        try {
            dispatch(getSalesStatsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/stats/sales', year, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getSalesStatsSuccess, getSalesStatsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getSalesStatsError));
        }
    };
}
function getSalesStatsRequest() {
    return {
        type: GET_SALES_STATS_REQUEST,
        isFetching: true
    };
}
function getSalesStatsSuccess (payload) {
    return {
        type: GET_SALES_STATS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getSalesStatsError(errorMessage) {
    return {
        type: GET_SALES_STATS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Get purchase stats
export function getPurchasesStats(year) {
    return async (dispatch) => {
        try {
            dispatch(getPurchasesStatsRequest());

            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/stats/purchases', year, { headers: { 'Authorization': 'Bearer ' + token } });

            dispatch(utilsLib.response(res, getPurchasesStatsSuccess, getPurchasesStatsError));
        } catch (err) {
            dispatch(utilsLib.response(err, getPurchasesStatsError));
        }
    };
}
function getPurchasesStatsRequest() {
    return {
        type: GET_PURCHASES_STATS_REQUEST,
        isFetching: true
    };
}
function getPurchasesStatsSuccess (payload) {
    return {
        type: GET_PURCHASES_STATS_SUCCESS,
        isFetching: false,
        error: false,
        payload
    };
}
function getPurchasesStatsError(errorMessage) {
    return {
        type: GET_PURCHASES_STATS_ERROR,
        isFetching: false,
        error: true,
        errorMessage
    };
}

// Clean series reducer
export function cleanStats() {
    return {
        type: 'CLEAN_STATS',
        isFetching: false,
        error: false,
        payload: []
    }
}



// WEBPACK FOOTER //
// ./src/actions/stats.js